import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { get } from "lodash";


class StageACompletedSteps{
  declaration: boolean;
  step_1: boolean;
  step_2: boolean;
  step_3: boolean;
  step_4: boolean;
  step_5: boolean;

  constructor(initial?: StageACompletedSteps){
    this.declaration = get(initial, 'declaration', false);
    this.step_1 = get(initial, 'step_1', false);
    this.step_2 = get(initial, 'step_2', false);
    this.step_3 = get(initial, 'step_3', false);
    this.step_4 = get(initial, 'step_4', false);
    this.step_5 = get(initial, 'step_5', false);
  }
}



export interface CompletedStepsStates {
  stage_a: StageACompletedSteps,
  step_a_success: boolean;
}

const initialState: CompletedStepsStates = {
  stage_a : new StageACompletedSteps(),
  step_a_success: false
};


const CompletedStepsSlice = createSlice({
  name:"Application Completed Slice",
  initialState,
  reducers:{
    updateStageAStepDeclaration: (state, action: PayloadAction<boolean>) => {
      state.stage_a = new StageACompletedSteps({...state.stage_a, declaration: action.payload});
    },
    updateStageAStep1: (state, action: PayloadAction<boolean>) => {
      state.stage_a = new StageACompletedSteps({...state.stage_a, step_1: action.payload});
    },
    updateStageAStep2: (state, action: PayloadAction<boolean>) => {
      state.stage_a = new StageACompletedSteps({...state.stage_a, step_2: action.payload});
    },
    updateStageAStep3: (state, action: PayloadAction<boolean>) => {
      state.stage_a = new StageACompletedSteps({...state.stage_a, step_3: action.payload});
    },
    updateStageAStep4: (state, action: PayloadAction<boolean>) => {
      state.stage_a = new StageACompletedSteps({...state.stage_a, step_4: action.payload});
    },
    updateStageAStep5: (state, action: PayloadAction<boolean>) => {
      state.stage_a = new StageACompletedSteps({...state.stage_a, step_5: action.payload});
    },
    updateStageASuccess: (state, action: PayloadAction<boolean>) => {
      state.step_a_success = action.payload;
    },
    resetStageA: (state) => {
      state.stage_a = new StageACompletedSteps();
      state.step_a_success = false;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(openStageASuccessRoute.fulfilled, (state, action) => {
      state.step_a_success = action.payload;
    });
  }
});

export const openStageASuccessRoute = createAsyncThunk(
  "openStageASuccessRoute",
  async (value:boolean, { fulfillWithValue, rejectWithValue }) => {
    return fulfillWithValue(value);
  }
);


export const { updateStageAStepDeclaration, updateStageAStep1,updateStageAStep2, updateStageAStep3, updateStageAStep4, updateStageAStep5, resetStageA, updateStageASuccess } = CompletedStepsSlice.actions;

export default CompletedStepsSlice.reducer;
